import { BASE_URL } from "config";
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import storesOrdersTableData from "./data/storesOrdersTableData";
import TextField from "@mui/material/TextField";
import { useMaterialUIController, setDirection } from "context";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import { Height } from "@mui/icons-material";
import { width } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import ordersDetailsTableData from "./ordersDetailsTableData";
import MDAvatar from "components/MDAvatar";
import OrdersDetailsDialog from "./ordersDetailsDialog";
import Box from "@mui/material/Box";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

function StoresOrders() {
  const [controller, dispatch] = useMaterialUIController();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openOrderDialog, setOpenOrderDialog] = useState(false);
  const [selectedOrderStore, setSelectedOrderStore] = useState(null);
  const [loadingOrderDetails, setLoadingOrderDetails] = useState(false);
  const [loading, setLoading] = useState(false);

  // إضافة حالة dialog التأكيد وsnackbar
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    type: "",
    user: null,
    newStatus: "",
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };

  // دالة إغلاق snackbar
  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  // حالة التحميل لكل طلب
  const [loadingOrderId, setLoadingOrderId] = useState(null);

  // دالة استدعاء API لتغيير الحالة
  const updateOrderStatus = async (user, newStatus) => {
    console.log("order is: ", user);
    console.log("newStatus is: ", newStatus);
    setLoadingOrderId(user.id);
    const token = localStorage.getItem("user-token");
    let url = "";
    if (newStatus === "processing") url = `${BASE_URL}/manager/orders/confirmed/${user.id}`;
    else if (newStatus === "shipped") url = `${BASE_URL}/manager/orders/shipped/${user.id}`;
    else if (newStatus === "completed") url = `${BASE_URL}/manager/orders/delivered/${user.id}`;
    else if (newStatus === "cancelled") url = `${BASE_URL}/manager/orders/cancelled/${user.id}`;
    else return;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("فشل في تغيير حالة الطلب");
      setSnackbar({ open: true, message: "تم تغيير حالة الطلب بنجاح", severity: "success" });
      fetchUsers();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "حدث خطأ أثناء تغيير الحالة",
        severity: "error",
      });
    } finally {
      setLoadingOrderId(null);
    }
  };

  // منطق التأكيد للحالات الحساسة
  const handleStatusChange = (user, newStatus) => {
    if (newStatus === "shipped" || newStatus === "cancelled") {
      setConfirmDialog({ open: true, type: newStatus, user, newStatus });
    } else {
      updateOrderStatus(user, newStatus);
    }
  };

  const handleConfirm = () => {
    if (confirmDialog.user && confirmDialog.newStatus) {
      updateOrderStatus(confirmDialog.user, confirmDialog.newStatus);
    }
    setConfirmDialog({ open: false, type: "", user: null, newStatus: "" });
  };

  const handleCancel = () => {
    setConfirmDialog({ open: false, type: "", user: null, newStatus: "" });
  };

  useEffect(() => {
    setDirection(dispatch, "rtl");
    fetchUsers();
    return () => setDirection(dispatch, "ltr");
  }, []);
  // get all store orders
  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/orders", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setUsers(data.data || []);
      console.log(data.data);
      console.log("user_token", token);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOrderDetailsClick = (orderStore) => {
    setSelectedOrderStore(orderStore);
    setLoadingOrderDetails(true);
    setOpenOrderDialog(true);
    setTimeout(() => setLoadingOrderDetails(false), 500);
  };
  const { columns, rows } = storesOrdersTableData(
    users,
    handleEditClick,
    fetchUsers,
    undefined,
    undefined,
    handleOrderDetailsClick,
    handleStatusChange,
    loadingOrderId
  );

  const filteredRows = rows.filter((row) => row.order_number.toString().includes(search));

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث
  }, [search, rowsPerPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة الطلبات
            </MDTypography>

            {/* <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              مستخدم جديد
            </MDButton> */}
          </MDBox>

          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="300px"
              py={6}
            >
              <CircularProgress size={60} sx={{ color: "#ca9937" }} />
            </Box>
          ) : (
            <MDBox pt={3} px={2}>
              <TextField
                fullWidth
                label="بحث برقم الطلب "
                variant="outlined"
                size="small"
                sx={{ mb: 3 }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <MDBox mb={2} display="flex">
                <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
              </MDBox>
              <DataTable
                table={{ columns, rows: paginatedRows }}
                isSorted={false}
                showTotalEntries={true}
                noEndBorder
                sx={{
                  "& .MuiTable-root": { minWidth: 1000 },
                  "& .MuiTableCell-root": {
                    py: 1.5,
                    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                  },
                  "& .MuiTableHead-root": {
                    backgroundColor: (theme) => theme.palette.grey[100],
                  },
                }}
              />

              {/* أزرار التحكم في الصفحات */}
              <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
                <MDButton
                  onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                  disabled={page === 0}
                  sx={{
                    background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                    color: "white",
                    borderRadius: "50%",
                    width: "50px",
                    height: "50px",
                    minWidth: "50px",
                    mx: 1,
                    "&:hover": {
                      background: "linear-gradient(90deg, #b6842f, #d39d45)",
                    },
                  }}
                >
                  <ArrowBackIcon />
                </MDButton>

                <MDTypography
                  variant="button"
                  color="text"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mx: 3,
                    fontWeight: "bold",
                  }}
                >
                  الصفحة {page + 1} من {Math.ceil(filteredRows.length / rowsPerPage)}
                </MDTypography>

                <MDButton
                  onClick={() =>
                    setPage((prev) =>
                      (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
                    )
                  }
                  disabled={(page + 1) * rowsPerPage >= filteredRows.length}
                  sx={{
                    background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                    color: "white",
                    borderRadius: "50%",
                    width: "50px",
                    height: "50px",
                    minWidth: "50px",
                    mx: 1,
                    "&:hover": {
                      background: "linear-gradient(90deg, #b6842f, #d39d45)",
                    },
                  }}
                >
                  <ArrowForwardIcon />
                </MDButton>
              </MDBox>
            </MDBox>
          )}
        </Card>
      </MDBox>

      <OrdersDetailsDialog
        open={openOrderDialog}
        onClose={() => setOpenOrderDialog(false)}
        orderStore={selectedOrderStore}
        loading={loadingOrderDetails}
      />

      {/* Dialog التأكيد */}
      <Dialog open={confirmDialog.open} onClose={handleCancel} maxWidth="sm" fullWidth>
        <DialogTitle>
          <MDBox display="flex" justifyContent="space-between" alignItems="center">
            <MDTypography variant="h6" color="text">
              {confirmDialog.type === "cancelled" ? "تأكيد إلغاء الطلب" : "تأكيد شحن الطلب"}
            </MDTypography>
            <IconButton onClick={handleCancel}>
              <CloseIcon />
            </IconButton>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDTypography variant="body1" color="text">
            {confirmDialog.type === "cancelled"
              ? "هل أنت متأكد من إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء."
              : "هل أنت متأكد من شحن هذا الطلب؟"}
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleCancel} color="secondary">
            إلغاء
          </MDButton>
          <MDButton
            onClick={handleConfirm}
            color={confirmDialog.type === "cancelled" ? "error" : "primary"}
            variant="contained"
          >
            {confirmDialog.type === "cancelled" ? "إلغاء الطلب" : "تأكيد الشحن"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default StoresOrders;
